/* ==========================================================================
  main.js
========================================================================== */

'use strict';

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});
